import * as React from "react";
const Reports = (props: any) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M15.852 0H8.1A8.11 8.11 0 0 0 0 8.1v7.8A8.11 8.11 0 0 0 8.1 24h7.8a8.11 8.11 0 0 0 8.1-8.1V8.1A8.11 8.11 0 0 0 15.852 0m2.268 12.828h-.168a.91.91 0 0 1-.888-.744l-.216-1.2-1.572 2.4a2.05 2.05 0 0 1-2.784.6l-2.724-1.728a.22.22 0 0 0-.156 0 .24.24 0 0 0-.156.096L6.672 15.96a.92.92 0 0 1-.72.36.9.9 0 0 1-.54-.18.9.9 0 0 1-.18-1.2l2.784-3.708a2.05 2.05 0 0 1 2.7-.516l2.736 1.728a.276.276 0 0 0 .336-.072l1.608-2.4-1.296.18a.902.902 0 0 1-1.053-1.073.9.9 0 0 1 .717-.703l3.312-.612h.432a.14.14 0 0 1 .096 0l.18.096.18.144q.065.078.108.168a.6.6 0 0 1 .072.18l.624 3.36a.9.9 0 0 1-.648 1.116"
            fill="currentColor"
        />
    </svg>
);
export default Reports;
